<template>
    <div>
        <div class="nav">
            <page-navigation v-bind:step="currentStep"></page-navigation>
        </div>
        <div class="button_panel">
            <button class="btn btn-padding_19" v-on:click="result()">查看结果</button>
            <button class="btn btn-padding_19" v-on:click="moreResult()">查看更多工作表</button>
            <button class="btn btn-padding_12" v-on:click="lastResult()">查看最近一次结果</button>
            <button class="btn btn-padding_19" v-on:click="download()">下载</button>
        </div>
        <div class="content_main">
          
            <div class="main_left">
                <h3 class="line_red">店铺选择</h3>
                <ul>
                    <li v-if="navList && navList.length > 0" v-bind:title="item.posId +''+ item.season +''+ item.store" v-bind:class="{active:currentNav == index}" class="nav_list" v-for="(item,index) in navList" v-on:click="changeStore(index,item)">
                        <p class="title_ellipsis">{{item.posId}}-{{item.season}}</p>
                        <p class="font_blod title_ellipsis">{{item.store}}</p>
                    </li>
                </ul>
            </div>
            <div class="main_right">
                <div class="main_right_top">
                    <div class="left_chart" style="position:relative">
                        <h3 class="line_blue no_padding_bottom">利润</h3>
                        <div class="title_align">预估利润</div>
                        <chart1 style="float:right;" ref="chart1" v-if="data1.hackReset" v-bind:setId="'main'" v-bind:yNanme="'预估利润'" v-bind:getData="data1" v-bind:chartWidth="'3.9rem'" v-bind:chartHeight="'3rem'"></chart1>
                    </div>
                    <div class="right_chart no_padding_bottom" style="position:relative">
                        <h3 class="line_green no_padding_bottom">服务</h3>
                        <div>
                          <div class="title_align">门店缺货计数</div>
                          <chart1 style="margin-left: 20px;" ref="chart2" v-if="data2.hackReset" v-bind:setId="'main1'" v-bind:yNanme="'门店缺货计数'" v-bind:getData="data2" v-bind:chartWidth="'3.9rem'" v-bind:chartHeight="'1.5rem'"></chart1>
                          <h3 class="line_green no_padding_bottom" style="position: absolute;top: 150px;">成本</h3>
                          <chart1 style="margin-left: 20px;" ref="chart3" v-if="data3.hackReset" v-bind:setId="'main2'" v-bind:yNanme="'成本'" v-bind:getData="data3" v-bind:chartWidth="'3.9rem'" v-bind:chartHeight="'1.5rem'"></chart1>
                        </div>
                    </div>
                </div>
                <div class="main_right_bottom no_padding_bottom">
                    <div style="overflow:hidden">
                      <h3 class="line_orange no_padding_bottom"></h3> 
                      <select v-if="data1.frequency && data1.frequency.length > 0" class="select_option" name="public-choice" v-model="frequencySelected" @change="getFrequencySelected">                                        
                        <option :value="item" v-for="item in data1.frequency" >{{item}}</option>                                    
                      </select>
                      <div class="select_title">
                        <span>补货频次</span>
                      </div>
                      <div class="element-a"  @mouseover="gifShow()" @mouseleave="gifHidden()" style="float: right; padding-right:10px;">
                        <img class="information"  src="../../assets/tipp_icon.png" style="float: right;">
                      </div>
                      <div class="gif-wrap" id="gif" v-show="ifShowB"
                       @mouseover="gifMouseOver" @mouseleave="gifMouseLeave">
                        <img class="head_tip" src="../../assets/tip_icon.png"/>
                        <div>
                          <span class="tip_content">滚动鼠标滑轮可缩放图表</span>
                        </div>
                      </div>
                    </div>
                    <chart2 ref="chart4" v-if="data4.hackReset" v-bind:setId="'main3'" v-bind:getData="data4" v-bind:chartWidth="'8.2rem'" v-bind:chartHeight="'2.9rem'"></chart2>
                </div>
            </div>
            <!--<iframe v-if="ifShowIframe" id="frameResult" name="frameResult" style="width: 827px;height:514px" v-bind:src="resultUrl" frameborder="0"></iframe>-->
        </div>
        <page-footer v-bind:footerStatus="status" v-bind:next="nextUrl" v-bind:prev="prevUrl"></page-footer>
        <tip v-if="ifShow  && sendMessage.length > 0" v-bind:status="sendStatus" v-bind:message="sendMessage"></tip>
        <div v-if="ifShowLoading">
          <div class="loading_bg"></div>
            <div class="loading_main">
              <div class="loadEffect">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div>
                <span class="loading_text">{{loadingMessage}}</span>
              </div>
            </div>
        </div>
        <div v-if="ifShowAlert" class="confirm">
          <div class="content">
            <div class="title">
              <span class="title_name">提示</span>
              <span class="close_icon" v-on:click="close()" title="关闭">X</span>
            </div>
            <div class="text">{{resultMessage}}</div>
          </div>
        </div>
    </div>
</template>
<script>
import PageNavigation from "@/components/common/PageNavigation";
import PageFooter from "@/components/common/PageFooter";
import Tip from "@/components/common/tip";
import Chart1 from '@/components/common/chart1'; 
import Chart2 from '@/components/common/chart2'; 
import { calculateSubmit, calculateStatus, getChartData, getSeasonStoreList, getType1ChartData, getType2ChartData, downloadReport, CheckHealth } from "../../util/api.js";
import { mapState, mapActions } from "vuex";

export default {
  name: "Result",
  data() {
    return {
      status: {
        type: "config",
        status: "end"
      },
      ifShowB: false,
      BFocused: false,
      prevUrl: "Calculate",
      nextUrl: "settingDays",
      currentStep: 5,
      currentNav: 0,
      minutes: "",
      ifShowLoading: false,
      sendStatus: false,
      sendMessage: "",
      ifShowIframe: false,
      ifRunSuccess: true,
      ifShowAlert:false,
      resultMessage:'',
      resultUrl:'',
      moreResultUrl:'',
      loadingMessage:'',
      ifHasTask:false, //true是有任务
      navList:[],
      mockMainData:[],
      mockMainData1:[],
      mockMainData2:[],
      mockMainData3:[],
      count:0,
      posId:'',
      season:'',
      sendData:{},
      targetDays:[],
      currentFrequency:'',
      data1: {
        list:[],
        hackReset:false
      },
      data2: {
        list:[],
        hackReset:false
      },
      data3: {
        list:[],
        hackReset:false
      },
      data4:{
        list:{
          "income": [],
          "profit": [],
          "avg": []
        },
        days:[],
        hackReset:false
      },
      targetDaysColor:[
        {
          color:"#1591D3",
          name:'4'
        },
        {
          color:"#FA9B18",
          name:'5'
        },
        {
          color:"#FAD218",
          name:'6'
        },
        {
          color:"#27B9FA",
          name:'7'
        },
        {
          color:"#3956CA",
          name:'8'
        },
        {
          color:"#3956CA",
          name:'9'
        },
        {
          color:"#FAD218",
          name:'10'
        },
        {
          color:"#27B9FA",
          name:'11'
        },
        {
          color:"#1591D3",
          name:'12'
        },
        {
          color:"#3956CA",
          name:'13'
        }
      ]
    };
  },
  components: { PageNavigation, PageFooter, Tip, Chart1, Chart2 },
  computed: mapState({
    ifShow: state => state.ifShowMessage
  }),
  methods: {
    setCookie:function(name, value, day) {
      if(day !== 0){     //当设置的时间等于0时，不设置expires属性，cookie在浏览器关闭后删除
      var expires = day * 24 * 60 * 60 * 1000;
        var date = new Date(+new Date()+expires);
        document.cookie = name + "=" + value + ";expires=" + date.toUTCString();
      }else{
      document.cookie = name + "=" + value;
      }
    },
    getCookie: function(name) {
      var arr;
      var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },
    gifShow() {
      this.ifShowB = true;
    },
    gifHidden() {
      if (!this.BFocused) {
        this.ifShowB = false;
      } else this.ifShowB = true;
    },
    gifMouseOver() {
      this.ifShowB = true;
      this.BFocused = true;
    },
    gifMouseLeave() {
      this.BFocused = false;
      this.ifShowB = false;
    },
    changeStore: function(i,item) {
      this.currentNav = i;
      this.count++;  //for test
      this.posId = item.posId;
      this.season = item.season;
      this.setCookie("posId",this.posId,1);
      this.setCookie("season",this.season,1);
      this.getChartData(this.getCookie("rstuserId"),this.posId,this.season);
    },
    result: function() {
      if (this.ifRunSuccess) {
        this.data1.hackReset = this.data2.hackReset= this.data3.hackReset = this.data4.hackReset = false
        let userId = this.getCookie('rstuserId');
        this.getChartData(userId,this.posId,this.season);
        if(this.resultMessage){
          this.ifShowAlert = true;
        }
      } else {
        this.ifShowAlert = true;
      }
    },
    moreResult: function() {
    	CheckHealth().then(function(res){
        	 if(res.data.success == true){
        	 	window.open('./moreResult');
        	 }
        });
    },
    lastResult: function() {
      this.data1.hackReset = this.data2.hackReset= this.data3.hackReset = this.data4.hackReset = false
      let userId = this.getCookie('rstuserId');
      this.getChartData(userId,this.posId,this.season);
    },
    close:function(){
      this.ifShowAlert = false;
      if(this.ifHasTask){
        this.getStatus();
        this.ifHasTask = false;
      }
    },
    download:function(){
      downloadReport({userId:this.getCookie('rstuserId')})
        .then(function(res) {
          let fileName = "报表数据";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(res.data, fileName + ".xlsx");
          } else {
            var a = document.createElement("a");
            a.download = fileName + ".xlsx";
            a.href = window.URL.createObjectURL(res.data);
            document.body.appendChild(a); // 修复firefox中无法触发click
            a.click();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getNavList:function(){
      let that = this;
      getSeasonStoreList({userId:this.getCookie('rstuserId')})
        .then(function(res){
          if(res.data.success == true){
            let data = Object.keys(res.data.result);
            data.forEach(element => {
              that.navList.push(
                {
                  season:res.data.result[element].season,
                  store:res.data.result[element].storeName,
                  posId:res.data.result[element].posId
                }
              )
            });
            that.posId = that.navList[0].posId;
            that.season = that.navList[0].season;
            that.setCookie("posId",that.posId,1);
            that.setCookie("season",that.season,1);
            let userId = that.getCookie('rstuserId');
            that.getChartData(userId,that.posId,that.season);
          }
        });
    },
    getChartData:function(userId,posId,season){
      let that = this;
      that.data1.hackReset = that.data2.hackReset = that.data3.hackReset = false;
      /*if(!!that.$refs.chart1){
        that.$refs.chart1.charts.showLoading();
        that.$refs.chart2.charts.showLoading();
        that.$refs.chart3.charts.showLoading();
        that.$refs.chart4.charts.showLoading();
      }*/
      that.data1.list = []; 
      that.data2.list = [];
      that.data3.list = [];
      getType1ChartData({userId:userId, posId:posId,season:season})
        .then(function(res){
          console.log(res);
          if(res.data.success){
            that.targetDays = res.data.result.targetDays;
            that.setCookie('targetDays',JSON.stringify(that.targetDays),1)
            that.data1.profitMapList;
            console.log(that.targetDays);
            that.targetDays.forEach((element,i) => {
              that.data1.list[i] = {};
              that.data1.list[i].name = element;
              that.data1.list[i].data = res.data.result.profitMapList[element];
              that.data2.list[i] = {};
              that.data2.list[i].name = element;
              that.data2.list[i].data = res.data.result.outOfStockMapList[element];
              that.data3.list[i] = {};
              that.data3.list[i].name = element;
              that.data3.list[i].data = res.data.result.costMapList[element];
              
            });
            that.setCookie('frequency',JSON.stringify(res.data.result.frequencies),1)
            that.data1.frequency = that.data2.frequency = that.data3.frequency = res.data.result.frequencies;
            if(!that.frequencySelected){
              that.frequencySelected = res.data.result.frequencies[0];
            }
            console.log(that.data1.list);
            console.log(that.data2.list);
            console.log(that.data3.list);
            that.data1.days = that.data2.days = that.data3.days = that.targetDays;
            /*if(!!that.$refs.chart1){
              that.$refs.chart1.drawPie("main");
              that.$refs.chart2.drawPie("main1");
              that.$refs.chart3.drawPie("main2");
              that.$refs.chart1.charts.hideLoading();
              that.$refs.chart2.charts.hideLoading();
              that.$refs.chart3.charts.hideLoading();
            }*/
            that.data1.hackReset = that.data2.hackReset = that.data3.hackReset = true;
            that.getChart2Data(userId,posId,season,that.frequencySelected);
          }
        })
    },
    getChart2Data:function(userId,posId,season,frequency){
      let that = this;
      that.data4.hackReset = false;
      that.data4.list['income'] = [];
      that.data4.list['profit'] = [];
      that.data4.list['avg'] = [];
      getType2ChartData({userId:userId, posId:posId,season:season,frequency:frequency, include:'true'})
        .then(function(res){
          let data = res.data.result;
          that.targetDays.forEach(element => {
            that.data4.list['income'].push(data[element].estimateProfit);
            that.data4.list['profit'].push(data[element].revenue);
            that.data4.list['avg'].push(data[element].isr);
          });
          console.log(that.data4);
          that.data4.days = that.targetDays;
          that.data4.hackReset = true;
          /*if(!!that.$refs.chart4){
            that.$refs.chart4.drawPie("main3");
            that.$refs.chart4.charts.hideLoading();
          }*/
        })
    },
    getFrequencySelected:function(){
      let userId = this.getCookie('rstuserId');
      this.getChart2Data(userId,this.posId,this.season,this.frequencySelected);
    },
    getStatus:function(data){
      let that = this;
      that.ifShowLoading = true;
      calculateStatus({userId: this.getCookie("rstuserId")})
        .then(function(res){
          if(res.data.queueEnd === false){
            that.loadingMessage = res.data.message;
            setTimeout( _ => {that.getStatus();},5000);
          }else{
            that.ifShowLoading = false;
            if (res.data.success) {
              that.resultMessage = res.data.message;
              if(that.resultMessage){
                that.ifShowAlert = true;
              }
              that.getNavList();
            } else {
              that.resultMessage = res.data.message?res.data.message:"计算失败";
              that.ifShowAlert = true;
              that.ifRunSuccess = false;
            }
          }
        })
    },
    init:function(){
      let season = this.$store.state.seasonchecked;
      let that = this;
      if (season.data) {
        let array = Object.keys(season.data);
        let count = 0;
        for(var i = 0; i < array.length; i++){
          count = count + season.data[array[i]].length;
        }
        this.minutes = count;
        this.ifShowLoading = true;
        this.sendData = {
          userId: this.getCookie("rstuserId"),
          posIdSeasons: season.data
        };
        this.loadingMessage = '预计需要'+ this.minutes * 2 + '分钟，请稍等';
        calculateSubmit(this.sendData)
          .then(function(res) {
            if (res.data.success) {
              that.loadingMessage = res.data.message;
              that.getStatus();
              return;
            } else if(!res.data.success){
              if(!!res.data.result){
                that.ifHasTask = true;
              }else{
                that.ifHasTask = false;
              }
              that.resultMessage = res.data.message?res.data.message:"计算失败";
              that.ifShowAlert = true;
              that.ifRunSuccess = false;
              that.ifShowLoading = false;
            }
          })
          .catch(function(err) {
            that.ifShowLoading = false;
            that.ifRunSuccess = false;
            that.ifShowAlert = true;
            that.resultMessage = "计算失败";
          });
      } else {
        that.getStatus();
      }
    }
  },
  mounted: function() {
    this.$store.commit("getIfShowMessage", false);
    this.init();
    //this.getNavList();
    /*if(process.env.ENV == 'dev'){
      this.resultUrl = 'http://r4wappq011:9100/t/nike/views/BenefitReport_v10_5_002Dashboard_Zoomin/Dashboard?iframeSizedToWindow=true&:embed=y&:display_count=no&:showAppBanner=false&:showVizHome=no&:refresh=y';
      this.moreResultUrl = 'http://r4wappq011:9100/t/nike/views/BenefitReport_v10_5_002nodashboard/KPI?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no&:refresh=y';
    }else if(process.env.ENV == 'uat'){
      this.resultUrl = 'http://r4wappq011:9100/t/nike/views/BenefitReport_v10_5_002Dashboard_Zoomin-UAT/Dashboard?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no&:refresh=y';
      this.moreResultUrl = 'http://r4wappq011:9100/t/nike/views/BenefitReport_v10_5_002worksheets-UAT/KPI?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no&:refresh=y';
    }else{
      this.resultUrl = 'http://gctableau.nike.com/t/nike/views/BenefitReport_Dashboard/Dashboard?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no&:refresh=y';
      this.moreResultUrl = 'http://gctableau.nike.com/t/nike/views/BenefitReport_worksheets/KPI?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no&:refresh=y';
    }*/
  }
};
</script>
<style scoped>
.nav {
  padding: 0.1rem 0 0.1rem 0;
}
@media screen and (max-height: 800px) {
    .content_main {
      background-color: #f7f7f7;
      margin: 0 auto;
      margin-bottom: 0.66rem;
      overflow: hidden;
      width: 900px;
    }
}
@media screen and (min-height: 800px) {
    .content_main {
      background-color: #f7f7f7;
      margin-bottom: 0.66rem;
      overflow: hidden;
      width: 900px;
      box-shadow: 0 0 5px -3px #000;
      margin-top: 0.2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
}
.content_main h3 {
  text-align: left;
  padding-bottom: 0.31rem;
}
.line_red:before,
.line_blue:before,
.line_green:before,
.line_orange:before {
  display: inline-block;
  width: 0.04rem;
  height: 0.24rem;
  vertical-align: middle;
  content: "";
  margin-right: 0.24rem;
}
.line_blue:before,
.line_green:before,
.line_orange:before {
  width: 0.02rem;
  height: 0.14rem;
}
.line_orange{
  width: 50%;
  float: left;
}
.line_red:before {
  background-color: #fa5400;
}
.line_blue:before {
  background-color: #0a8cd1;
}
.line_green:before {
  background-color: #99cd00;
}
.line_orange:before {
  background-color: #fa5502;
}
.button_panel {
  text-align: right;
  padding-bottom: 0.05rem;
  width: 10.34rem;
  margin: 0 auto;
}
.btn {
  height: 0.36rem;
  font-size: 0.15rem;
  border: 1px solid #000;
  border-radius: 3px;
  color: #000;
  background-color: #fff;
  cursor: pointer;
}
.btn:hover{
  font-weight: bold;
  border: 1px solid #fa5400;;
}
.btn-padding_19 {
  padding: 0 0.19rem;
}
.btn-padding_12 {
  padding: 0 0.12rem;
}
.main_left {
  float: left;
  width: 2.08rem;
  height: 7.12rem;
  background-color: #fff;
  padding-top: 0.15rem;
  box-shadow: 0 0 4px -3px #000;
  margin: 0.05rem 0.18rem 0.05rem 0.05rem;
}
.main_right {
  float: left;
}
.main_right_top {
  overflow: hidden;
  margin-bottom: 0.07rem;
}
.left_chart,
.right_chart {
  float: left;
  background-color: #fff;
  width: 4.16rem;
  height: 3.5rem;
  margin: 0.05rem;
  box-shadow: 0 0 4px -3px #000;
  padding-top: 0.09rem;
}
.main_right_bottom {
  margin-left: 0.05rem;
  background-color: #fff;
  width: 8.43rem;
  height: 3.49rem;
  box-shadow: 0 0 4px -3px #000;
  padding-top: 0.09rem;
}
.nav_list {
  height: 0.75rem;
  padding: 0.12rem 0;
  line-height: 0.25rem;
  margin-bottom: 4px;
  background-color: #fff;
  cursor: pointer;
  position: relative;
}
.nav_list.active {
  background-color: #f6f6f6;
}
.nav_list.active::before {
  content: '';
  width: 100px;
  height: 2px;
  background: #fa5805;
  display: block;
  position: absolute;
  bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
}
li.nav_list.active::after {
  content: "";
  display: block;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-left: 10px solid #fa5805;
  position: relative;
  top: -0.32rem;
  left: 0.04rem;
}
.nav_list p {
  padding-left: 0.25rem;
  text-align: left;
  height: 20px;
}
.font_blod {
  font-weight: bold;
}
.loadEffect {
  width: 70px;
  height: 70px;
  position: relative;
  margin: 0 auto;
  margin-top: 200px;
}
.loadEffect span {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #666;
  position: absolute;
  -webkit-animation: load 1.04s ease infinite;
  -moz-animation: load 1.04s ease infinite;
  -ms-animation: load 1.04s ease infinite;
  -o-animation: load 1.04s ease infinite;
  animation: load 1.04s ease infinite;
}
@-webkit-keyframes load {
  0% {
    -webkit-transform: scale(1.2);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0.3);
    opacity: 0.5;
  }
}
@-moz-keyframes load {
  0% {
    -moz-transform: scale(1.2);
    opacity: 1;
  }
  100% {
    -moz-transform: scale(0.3);
    opacity: 0.5;
  }
}
@-ms-keyframes load {
  0% {
    -ms-transform: scale(1.2);
    opacity: 1;
  }
  100% {
    -ms-transform: scale(0.3);
    opacity: 0.5;
  }
}
    
@-o-keyframes load {
  0% {
    -o-transform: scale(1.2);
    opacity: 1;
  }
  100% {
    -o-transform: scale(0.3);
    opacity: 0.5;
  }
}
    
@keyframes load {
  0% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(0.3);
    opacity: 0.5;
  }
}
.loadEffect span:nth-child(1) {
  left: 0;
  top: 50%;
  margin-top: -5px;
  -webkit-animation-delay: 0.13s;
  -moz-animation-delay: 0.13s;
  -ms-animation-delay: 0.13s;
  -o-animation-delay: 0.13s;
  animation-delay: 0.13s;
}
.loadEffect span:nth-child(2) {
  left: 9px;
  top: 9px;
  -webkit-animation-delay: 0.26s;
  -moz-animation-delay: 0.26s;
  -ms-animation-delay: 0.26s;
  -o-animation-delay: 0.26s;
  animation-delay: 0.26s;
}
.loadEffect span:nth-child(3) {
  left: 50%;
  top: 0;
  margin-left: -5px;
  -webkit-animation-delay: 0.39s;
  -moz-animation-delay: 0.39s;
  -ms-animation-delay: 0.39s;
  -o-animation-delay: 0.39s;
  animation-delay: 0.39s;
}
.loadEffect span:nth-child(4) {
  top: 9px;
  right: 9px;
  -webkit-animation-delay: 0.52s;
  -moz-animation-delay: 0.52s;
  -ms-animation-delay: 0.52s;
  -o-animation-delay: 0.52s;
  animation-delay: 0.52s;
}
.loadEffect span:nth-child(5) {
  right: 0;
  top: 50%;
  margin-top: -5px;
  -webkit-animation-delay: 0.65s;
  -moz-animation-delay: 0.65s;
  -ms-animation-delay: 0.65s;
  -o-animation-delay: 0.65s;
  animation-delay: 0.65s;
}
.loadEffect span:nth-child(6) {
  right: 9px;
  bottom: 9px;
  -webkit-animation-delay: 0.78s;
  -moz-animation-delay: 0.78s;
  -ms-animation-delay: 0.78s;
  -o-animation-delay: 0.78s;
  animation-delay: 0.78s;
}
.loadEffect span:nth-child(7) {
  bottom: 0;
  left: 50%;
  margin-left: -5px;
  -webkit-animation-delay: 0.91s;
  -moz-animation-delay: 0.91s;
  -ms-animation-delay: 0.91s;
  -o-animation-delay: 0.91s;
  animation-delay: 0.91s;
}
.loadEffect span:nth-child(8) {
  bottom: 9px;
  left: 9px;
  -webkit-animation-delay: 1.04s;
  -moz-animation-delay: 1.04s;
  -ms-animation-delay: 1.04s;
  -o-animation-delay: 1.04s;
  animation-delay: 1.04s;
}
.loading_bg {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 100%;
  height: 100%;
  background-color: #fff;
  opacity: 0.5;
}
.loading_main {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 100%;
  height: 100%;
}
.loading_text {
  color: #c2c2c2;
  font-size: 14px;
}
.confirm{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #0006;
}
.confirm .content{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 360px;
    height: 150px;
    border: 1px solid #eeeeee;
    border-radius: 2px;
    background-color: #fff;
}
.confirm .title{
    height: 40px;
    text-align: left;
    line-height: 40px;
    padding-left: 20px;
    background: #eeeeee;
}
.confirm .title_name{
  font-weight: bold;
}
.confirm .close_icon{
  float: right;
  padding: 0 20px;
  cursor: pointer;
}
.confirm .text{
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #ff5b5b;
    padding:0 20px;
}
.content_main .no_padding_bottom{
  padding-bottom: 0;
}
.select_option{
  float: right;
  margin-right: 20px;
}
.select_title{
  float: right;
  margin-right: 10px;
}
.download_btn{
    position: fixed;
    bottom: 60px;
    right: 50px;
    cursor: pointer;
}
.color_block{
    width: 10px;
    height: 10px;
    display: inline-block;
    float: left;
    margin-right: 10px;
    margin-left: 10px;
}
.title_ellipsis{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.title_align{
    font-size: 12px;
    margin-left: -7px;
    transform: scale(0.833);
    text-align: left;
    position: absolute;
    left: 23px;
}
.element-a:hover {
  cursor: pointer;
  opacity: 1;
}
.information{
  padding-top: 1px;
}
.tip_content{
    padding: 0.08rem 0.2rem;
    color: #fff;
    position: absolute;
    margin-top: -0.45rem;
    margin-left: 0.35rem;
}
.tip_content span{
    display: block;
    line-height: 20px;
    width: auto!important;
}
.head_tip{
    position: absolute;
    margin-top: -0.5rem;
    margin-left: 0.35rem;
    transform:rotate(180deg);
    -ms-transform:rotate(180deg); 	/* IE 9 */
    -moz-transform:rotate(180deg); 	/* Firefox */
    -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
    -o-transform:rotate(180deg); 
    height: 0.8rem;
}
img.head_tip {
  height: 0.5rem;
  width: 2rem
}
</style>





// WEBPACK FOOTER //
// src/components/page/ShowResult.vue